module.exports = __webpack_public_path__ + "img/MoDesk4.52037084.png";